export default "__VITE_ASSET___roUMest__"